import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import {DomainService} from '../../../services/domain.service';
import {NotificationService} from '../../../services/notification.service';
import {EnvironmentService} from '../../../services/environment.service';

@Component({
    selector: 'itpx-evaluation-course-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.css']
})
export class EvaluationCourseTileComponent {
    @Input() target: Array<any> = [];
    @Input() name: string;
    @Input() isClass: boolean;
    @Input() imageUrl: string;
    @Input() tile: any;
    @Input() percentage: any;
    @Input() type: any;
    @Input() assignment: any;

    private domain: any;
    private images: string;
    private isElearning: boolean = false;
    private course:any;

    constructor(
        private router: Router,
        private domainService: DomainService,
        private notificationService: NotificationService,
        private environmentService: EnvironmentService
    ) {
    }

    ngOnInit() {
        this.domain = this.domainService.getDomain();
        this.images = this.environmentService.config['server'].images;

        this.isElearning = this.type === 'eLearning';

        if(this.assignment.productVariant)
          this.course = {
            title: this.assignment.productVariant.name,
            product: {
              certificateType: this.removeDashes(this.assignment.productVariant.certificateType),
              deliveryFormat: this.removeDashes(this.assignment.productVariant.deliveryFormat),
              language: this.assignment.productVariant.languageValue
            },
            startedOn: this.assignment.startedOn,
            finishedOn: this.assignment.finishedOn
          }
    }

  private removeDashes(val: string): string {
    return val ? val.replace('-', ' ') : null;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/course/tile.component.ts